(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sliders = document.querySelectorAll('.hero-slider');

    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll('.hero-slider__slide');
      const dots = slider.querySelectorAll('.hero-slider__dot');
      const autoplayMs = parseInt(slider.dataset.autoplayMs, 10) || 5000;
      const slideCount = slides.length;

      if (slideCount <= 1) return;

      let currentIndex = 0;
      let timer = null;

      const goTo = (index) => {
        slides[currentIndex].classList.remove('is-active');
        if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
        currentIndex = (index + slideCount) % slideCount;
        slides[currentIndex].classList.add('is-active');
        if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
      };

      const next = () => goTo(currentIndex + 1);

      const start = () => {
        stop();
        timer = setInterval(next, autoplayMs);
      };

      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = parseInt(dot.dataset.slideTarget, 10);
          goTo(target);
          start();
        });
      });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!reducedMotion.matches) {
        start();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
